import { useMutation } from '@tanstack/react-query';

import { Merchant } from '~/types/merchant';
import { MutationProps } from '~/types/mutation';
import { queryClient } from '~/utils';

import { model } from '../';

import { merchantsQueryKey } from './useMerchants';

export const useEditMerchant = ({ onSuccess }: MutationProps<Merchant>) =>
  useMutation(model.patch, {
    onSuccess: (data) => {
      queryClient.invalidateQueries([merchantsQueryKey]);
      onSuccess?.(data);
    },
  });
